import { createSelector } from 'reselect'

import { selectPartnerSearchState } from './selectPartnerSearchState'

export const selectPartnersDataState = createSelector(
  [selectPartnerSearchState],
  ({ partners }) => partners
)
